import InputMatrix from './InputMatrix';
import './InputMatrix.scss';

export default InputMatrix;
